export interface PermissionItem {
  page_key: string;
  page_name: string;
  module_group: string;
  permission: "accessible" | "restricted" | "hidden";
}

export interface RolePermissionGroup {
  role_level: string;
  role_label: string;
  role_desc: string;
  permissions: PermissionItem[];
}

export const allPages = [
  { page_key: "home", page_name: "首頁", module_group: "首頁" },
  { page_key: "manager-center", page_name: "主管中心", module_group: "工作中心" },
  { page_key: "customer-service", page_name: "客服中心", module_group: "工作中心" },
  { page_key: "knowledge-base", page_name: "知識中心", module_group: "工作中心" },
  { page_key: "department-chat", page_name: "部門通訊", module_group: "工作中心" },
  { page_key: "notifications", page_name: "通知中心", module_group: "工作中心" },
  { page_key: "products", page_name: "商品管理", module_group: "營運管理" },
  { page_key: "shipping", page_name: "貨運追蹤", module_group: "營運管理" },
  { page_key: "accounting", page_name: "帳務管理", module_group: "營運管理" },
  { page_key: "employees", page_name: "員工管理", module_group: "系統管理" },
  { page_key: "salary", page_name: "薪資管理", module_group: "系統管理" },
  { page_key: "rbac", page_name: "權限設定", module_group: "系統管理" },
  { page_key: "system-settings", page_name: "系統設定", module_group: "系統管理" },
  { page_key: "operation-log", page_name: "操作紀錄", module_group: "系統管理" },
  { page_key: "profile", page_name: "個人中心", module_group: "個人中心" },
  { page_key: "clock-in-record", page_name: "打卡紀錄", module_group: "個人中心" },
  { page_key: "my-applications", page_name: "我的申請", module_group: "個人中心" },
];

export const defaultPermissions: Record<string, PermissionItem[]> = {
  admin: allPages.map((p) => ({ ...p, permission: "accessible" })),
  manager: allPages.map((p) => ({
    ...p,
    permission:
      p.module_group === "系統管理" && p.page_key !== "operation-log"
        ? "hidden"
        : "accessible",
  })),
  employee: allPages.map((p) => ({
    ...p,
    permission: p.module_group === "系統管理" ? "hidden" : "accessible",
  })),
  trial: allPages.map((p) => ({
    ...p,
    permission:
      p.module_group === "首頁"
        ? "accessible"
        : p.module_group === "系統管理"
          ? "hidden"
          : "restricted",
  })),
  suspended: allPages.map((p) => ({ ...p, permission: "hidden" })),
};

export const roleTabs = [
  { value: "admin", label: "超級管理員" },
  { value: "manager", label: "主管" },
  { value: "employee", label: "一般職員" },
  { value: "trial", label: "試用期兼職" },
  { value: "suspended", label: "停職" },
];

export const roleDescriptions: Record<string, string> = {
  admin: "擁有全部組件操作權限，可建立／編輯／刪除員工檔案與系統設定。",
  manager: "可執行主管層級業務操作，系統管理功能僅限操作紀錄。",
  employee: "可執行日常業務操作，系統管理功能僅供檢視。",
  trial: "部分功能受限，需主管審核後開通完整權限。",
  suspended: "帳號已暫停，所有功能均無法使用。",
};

export const permissionOptions = [
  { value: "accessible", label: "可操作", dot: "bg-primary-500" },
  { value: "restricted", label: "受限", dot: "bg-secondary-500" },
  { value: "hidden", label: "隱藏", dot: "bg-accent-500" },
];

export const permissionBadge: Record<
  string,
  { bg: string; text: string; label: string; dot: string }
> = {
  accessible: {
    bg: "bg-primary-50",
    text: "text-primary-700",
    label: "可操作",
    dot: "bg-primary-500",
  },
  restricted: {
    bg: "bg-secondary-50",
    text: "text-secondary-700",
    label: "受限",
    dot: "bg-secondary-500",
  },
  hidden: {
    bg: "bg-accent-50",
    text: "text-accent-700",
    label: "隱藏",
    dot: "bg-accent-500",
  },
};